__turbopack_context__.v({
  "product-messages": "ProductMessages-module-scss-module__atK_Yq__product-messages",
  "product-messages__item": "ProductMessages-module-scss-module__atK_Yq__product-messages__item",
  "product-messages__toggle": "ProductMessages-module-scss-module__atK_Yq__product-messages__toggle",
});
